import React from "react";
import { Check, CalendarClock, Bot, Globe, UploadCloud, ChevronRight } from "lucide-react";
import { ABOUT } from "../mock";

const ICONS = { CalendarClock, Bot, Globe, UploadCloud };

export default function About() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="about" className="section-pad" style={{ background: "#f5f8fd" }}>
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          {/* Left */}
          <div>
            <div className="site-heading">
              <h4>{ABOUT.subheading}</h4>
              <h2>{ABOUT.heading}</h2>
            </div>
            <p className="text-slate-500 leading-relaxed mb-7">{ABOUT.text}</p>
            <button className="btn-theme mb-9" onClick={() => scrollTo("#contact")}>
              {ABOUT.cta} <ChevronRight size={18} />
            </button>

            <div className="bg-white rounded-2xl border border-slate-100 p-7">
              <h3 className="text-lg font-semibold mb-5" style={{ color: "#141b34" }}>
                {ABOUT.benefitsTitle}
              </h3>
              {ABOUT.benefits.map((b) => (
                <div className="about-check" key={b}>
                  <span className="ic">
                    <Check size={15} strokeWidth={3} />
                  </span>
                  <span className="text-[15px] text-slate-600 leading-relaxed">{b}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:pt-4">
            {ABOUT.services.map((s, i) => {
              const Icon = ICONS[s.icon] || Globe;
              return (
                <div
                  key={s.title}
                  className={`service-mini ${i % 2 === 1 ? "sm:mt-10" : ""}`}
                >
                  <div className="ic">
                    <Icon size={40} strokeWidth={1.5} />
                  </div>
                  <h4 className="text-[17px] font-semibold leading-snug" style={{ color: "#141b34" }}>
                    {s.title}
                  </h4>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
